import {
  Box,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { SelectButton } from "../../utils/constants/Buttons.constants";
import { styles } from "./Styles";
import Search from "../../static/SVG/search.svg";
import { Constants, FormValues } from "../../utils/constants/Constants";

const ViewHeader = ({
  heading,
  formik,
  rowsPerPage,
  handleChangeRowsPerPage,
  getList,

  onlyHeading,
  totalRowCount,
  children,
}) => {
  const classes = styles;
  return (
    <Grid
      container
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{ mb: 2 }}
      spacing={2}
    >
      <Grid item md={4} xs={12} order={{ xs: 1 }} sm={4}>
        <Typography variant="h4" sx={classes.headingApp}>
          {heading}
        </Typography>
      </Grid>
      {!onlyHeading && (
        <>
          <Grid md={3} xs={12} item order={{ md: 2, xs: 3 }}>
            <form onSubmit={formik.handleSubmit}>
              <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                <TextField
                  name={FormValues.FORM_USER_INPUT_NAME_SEARCH}
                  placeholder={FormValues.FORM_USER_INPUT_NAME_SEARCH}
                  variant={Constants.VARIANT_OUTLINED}
                  size={Constants.FONT_SIZE_SMALL}
                  value={formik.values.search}
                  onChange={formik.handleChange}
                  fullWidth
                  InputProps={{
                    sx: { ...classes.searchTextfield },
                    endAdornment: (
                      <IconButton edge="end" disableRipple type="submit">
                        <img src={Search} />
                      </IconButton>
                    ),
                  }}
                />
              </Box>
            </form>
          </Grid>
          <Grid item md={5} xs={12} order={{ md: 3, xs: 2 }} sm={8}>
            <Box
              display={"flex"}
              alignItems={"center"}
              flexWrap={"wrap"}
              rowGap={"10px"}
              justifyContent={{
                md: "flex-end",
                xs: "flex-start",
                sm: "flex-end",
              }}
            >
              {children}
              <Box display={"flex"} alignItems={"center"}>
                <FormControl>
                  <SelectButton
                    rowsPerPage={rowsPerPage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    getList={getList}
                    totalRowCount={totalRowCount}
                  />
                </FormControl>
                <Typography sx={{ mx: 1 }} noWrap>
                  {Constants.RECORDS_PER_PAGE}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ViewHeader;
